export default "__VITE_ASSET__CjL1tsYm__"